import { render, staticRenderFns } from "./ProductLicencePeriodEdit.vue?vue&type=template&id=1ebc6dec&scoped=true&"
import script from "./ProductLicencePeriodEdit.vue?vue&type=script&lang=js&"
export * from "./ProductLicencePeriodEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebc6dec",
  null
  
)

export default component.exports